<template>
  <div class="matrix-auto max-w-full" style="width: fit-content">
    <q-table
      :view="view"
      disabled-row
      :rows="issue.rows"
      :columns="issue.items"
      show-required
      style="padding-right: 30px"
      :widths="issue.widths"
    >
      <template v-slot:content="{ col, row, rowIndex, colIndex }">
        <div class="relative">
          <compose-item
            :row="row"
            :col="col"
            :cell="issue.getCellByItemId(col.id)"
            :cache-value="issue.getValueByRowAndCol(row, col)"
            @change="onChangeValue"
          />
          <template v-if="rowIndex === issue.rows.length - 1 && colIndex === issue.items.length - 1">
            <template v-if="issue.rows.length > issue.min_row_num">
              <div class="absolute" style="right: -40px; top: 2px">
                <!--                <el-button type="text" @click="onDeleteRow(rowIndex)">删除</el-button>-->
                <span class="text-red cursor-pointer text-large" @click="onDeleteRow(rowIndex)">
                  <i class="el-icon-remove"></i>
                </span>
              </div>
            </template>
          </template>
          <template v-if="row.errMap[col.id]">
            <div>
              <span class="text-red mt-1 text-small">{{ row.errMap[col.id] }}</span>
            </div>
          </template>
        </div>
      </template>
    </q-table>
    <!--    <el-table border :data="issue.rows">
          <el-table-column
              v-for="(item, index) in issue.items"
              :column-key="item.id"
              :key="item.id"
              :className="index === issue.items.length - 1 ? 'matrix-auto-table-cell' : ''"
          >
            <template v-slot:header>
              <div v-html="item.content.richText"></div>
            </template>
            <template v-slot:default="{ row }">
              <div class="relative">
                <compose-item
                    :row="row"
                    :col="item"
                    :cell="issue.getCellByItemId(item.id)"
                    :cache-value="issue.getValueByRowAndCol(row, item)"
                    @change="onChangeValue"
                />
                <template v-if="row.errMap[item.id]">
                  <div>
                    <span class="text-red mt-1 text-small">{{ row.errMap[item.id] }}</span>
                  </div>
                </template>
              </div>
            </template>
          </el-table-column>
          <el-table-column width="60">
            <template v-slot:default="scope">
              <template v-if="scope.$index === issue.rows.length - 1 && issue.rows.length > issue.min_row_num">
                <el-button type="text" @click="onDeleteRow(scope.$index)">删除</el-button>
              </template>
            </template>
          </el-table-column>
        </el-table>-->
    <template v-if="issue.can_add_row && issue.rows.length < issue.max_row_num">
      <div @click="addRow" class="text-center text-medium">
        <div
          class="cursor-pointer text-theme-text-gray py-1.5 border border-border-gray border-dashed mt-2 hover:border-theme hover:text-theme"
        >
          <span>+ 继续填写</span>
        </div>
      </div>
      <!--      <el-button class="mt-2 w-full" @click="addRow">继续填写</el-button>-->
    </template>
  </div>
</template>

<script>
import MatrixTable from '@/questions/components/MatrixTable'
import ComposeItem from '@/questions/components/ComposeItem'
import QTable from '@/questions/components/QTable'

export default {
  name: 'MatrixAuto',
  changeExpr: 'issue.value',
  components: { QTable, ComposeItem, MatrixTable },
  methods: {
    onChangeValue(value) {
      this.issue.addValue(value.slice())
    },
    addRow() {
      this.issue.addRow()
    },
    onDeleteRow(index) {
      this.issue.deleteRow(index)
    }
  }
}
</script>
